<template>
  <div id="profile-tips">
    <article
      v-for="tip in tips"
      :key="tip.key"
      class="message is-success"
    >
      <div class="message-body">
        {{ tip }}
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'ProfileTips',
  props: {
    tips: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss">
</style>
